var map = {
	"./black/quxiaoquantijingyin2.png": "FkwF",
	"./blue/quxiaoquantijingyin2.png": "BhhB",
	"./white/quxiaoquantijingyin2.png": "/tn7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "FdUV";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/quxiaoquantijingyin2\.png$
// module id = FdUV
// module chunks = 24